module.exports = __webpack_public_path__ + "static/media/BR_image.3ca8da43.mp3";